import PropTypes from 'prop-types'
import clsx from 'clsx'
import React from 'react'
import { withI18next } from 'lib/i18n/withI18next'
import { POMELO_STORES_LOCATION_DETAILS } from 'pages/offline/const'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import { BUTTON_TYPES } from 'constants/button'
import Button from 'components/common/button'
import Typo from 'constants/typography'
import StoreDetails from '../store-details'
import styles from '../style.scss'

const StoreInformation = ({ address, t }) => (
  <React.Fragment>
    <style jsx>{styles}</style>
    <span className={Typo.body2}>{address.address1}</span>
    <Button
      className="PUAC__call-us_button webview-cta"
      link
      type={BUTTON_TYPES.outlinedLight}
      aProps={{ href: `tel:${address.phone}` }}
    >
      <Icon src={ICONS.pickupPhone} size={ICON_SIZE.medium} />
      {hasLocizeTranslation(
        t,
        POMELO_STORES_LOCATION_DETAILS.keyCallUs,
        POMELO_STORES_LOCATION_DETAILS.textCallUs,
      )}
      {address?.phone && (
        <span className={clsx('PUAC__call-us_tel', Typo.button)}>
          {address.phone}
        </span>
      )}
    </Button>
    <StoreDetails address={address} />
  </React.Fragment>
)

StoreInformation.propTypes = {
  t: PropTypes.func.isRequired,
  address: PropTypes.shape({
    address1: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
}

export default withI18next()(StoreInformation)
